// extracted by mini-css-extract-plugin
export var button = "resourceCards-module--button--32f1c";
export var card = "resourceCards-module--card--d7bf8";
export var cardImage = "resourceCards-module--cardImage--84ca4";
export var cardTitle = "resourceCards-module--cardTitle--2bdb7";
export var grayLine = "resourceCards-module--grayLine--defdc";
export var header = "resourceCards-module--header--b4cea";
export var resourceCards = "resourceCards-module--resourceCards--c2e3c";
export var resourceCardsHeader = "resourceCards-module--resourceCardsHeader--9be3b";
export var resourceCardsHeaderButton = "resourceCards-module--resourceCardsHeaderButton--bd384";
export var resourceCardsHeaderText = "resourceCards-module--resourceCardsHeaderText--5d151";